import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import hospitalReducer from './hospitalSlice';
import cityReducer from './citySlice';
import languageReducer from './languageSlice';
import languageTierReducer from './languageTierSlice';

import stateReducer from './stateSlice';
import interpreterReducer from './interpreterSlice';
import vendorReducer from './vendorSlice';
import adminReducer from './adminSlice';
import profileReducer from './profileSlice';
import availibilityReducer from './availibilitySlice';

// crm slices imports

import typesReducer from './typeSlice';
import accountReducer from './accountSlice';
import templateReducer from './templateSlice';
import staffReducer from './staffSlice';
import subUserReducer from './subUserSlice';
import departmentReducer from './departmentSlice';
import facilityReducer from './facilitiesSlice'; 
import appointmentReducer from './appointmentSlice';
import dashboardReducer from './dashboardSlice'; 
import permissionReducer from './permissionGroupSlice'; 
import appReducer from './appSlice'; 
import extensionsReducer from './extensionsSlice'; 
import actionButtonReducer from './actionButtonSlice'; 
import inviteInterpreterReducer from './inviteInterpreterSlice';
import interviewInvitesReducer from './interviewInviteSlice';
import invoiceReducer from './invoiceSlice';
import paymentReducer from './paymentSlice';

import mainAccountDashboardReducer from './mainAccount/dashboardSlice';
import mainSubAccountReducer from './mainAccount/subAccountSlice';      
import mainAccountInvoiceReducer from './mainAccount/mainAccountInvoiceSlice';      
import mainAccountProfileReducer from './mainAccount/mainAccountProfileSlice';      
import mainAccountAppointmentReducer from './mainAccount/mainAccountAppointmentSlice'; 

import interpreterDashboardReducer from './interpreter/dashboardSlice'; 
import interpreterPaymentReducer from './interpreter/paymentSlice';     
import interpreterProfileReducer from './interpreter/profileSlice';      
import interpreterAppointmentReducer from './interpreter/appointmentSlice'; 

export default combineReducers({
    user: userReducer,
    profile: profileReducer,
    hospital: hospitalReducer,
    city: cityReducer,
    language: languageReducer,
    languageTier: languageTierReducer,
    state: stateReducer,
    vendor: vendorReducer, 
    admin: adminReducer,
    availibility: availibilityReducer,


    // crm slices
    types: typesReducer,
    accounts: accountReducer,
    templates: templateReducer,
    staff: staffReducer,
    subUser: subUserReducer,
    interpreter: interpreterReducer,
    departments: departmentReducer,
    facilities: facilityReducer,
    appointments: appointmentReducer,
    dashboard : dashboardReducer,
    permission : permissionReducer,
    appStates: appReducer,
    actionButton: actionButtonReducer,
    extension: extensionsReducer,
    inviteInterpreters: inviteInterpreterReducer,
    invoices: invoiceReducer,
    interviewInvites: interviewInvitesReducer,
    payment: paymentReducer,

    // main account access 
    mainAccountDashboard : mainAccountDashboardReducer,
    mainSubAccounts: mainSubAccountReducer,
    mainAccountInvoice: mainAccountInvoiceReducer,
    mainAccountProfile: mainAccountProfileReducer,
    mainAccountAppointments: mainAccountAppointmentReducer,

    // Interpreter access 
    interpreterDashboard : interpreterDashboardReducer,
    payment: interpreterPaymentReducer,
    interpreterProfile: interpreterProfileReducer,
    interpreterAppointments: interpreterAppointmentReducer,
});
